import { Icon, Flex } from '@podiumhq/design-system';

const defaultIconProps = {
  boxSize: 4,
  color: 'silver.lightest',
};

const PodiumLogoIcon = ({
  backgroundColor = 'black.base',
  borderRadius = '8px',
  iconProps = defaultIconProps,
  ...wrapperProps
}) => (
  <Flex
    align="center"
    backgroundColor={backgroundColor}
    borderRadius={borderRadius}
    justify="center"
    paddingLeft="3px"
    {...wrapperProps}
  >
    <Icon type="Logo" {...iconProps} />
  </Flex>
);

export default PodiumLogoIcon;
